function shouldBlockTooltipEvents(event) {
  return event.composedPath().some(path => {
    const dataset = path.dataset;
    return dataset != null && dataset.blockTooltipEvents === 'true';
  });
}

export { shouldBlockTooltipEvents };
